export enum AppSections {
  ACCOUNT_CHANGE = 'Account_Change',
  ACCOUNT_INFORMATION = 'Account',
  ACCOUNT_TRANSFER = 'Account_Portfolio_Transfer',
  DEMARCATION = 'Demarcation',
  ACTIVITIES = 'Activities',
  ADD_GUARANTOR_OTHER_SEC = 'Add_Guarantor_Other_Sec',
  ARRANGEMENT_TO_PAY = 'Arrangement_To_Pay',
  ARREARS = 'Arrears',
  BASE_RATE_CHANGES = 'Base_Rate_Changes',
  BASE_RATE_TYPES = 'Base_Rate_Changes',
  BUSINESS_RULES = 'Workflow_SystemAdmin',
  BREATHING_SPACE = 'Breathing_Space',
  CALLS = 'Activities',
  CHART_ARREARS = 'Chart_Arrears',
  CHART_COMPLAINTS = 'Chart_Complaints',
  CHART_DELINQUENCY = 'Chart_Delinquency',
  CHART_LOAN_MATURITY_DISTRIBUTION = 'Chart_Loan_Maturity_Distribution',
  CHART_TO_DO_LIST = 'Chart_To_Do_List',
  CHART_VULNERABILITY = 'Chart_Vulnerability',
  CHART_ACCOUNT_ATDATE = 'Chart_Account_As_AtDate_Summary',
  CHART_BUSINESS_RULE = 'Chart_BusinessRule_History',
  COMPLAINTS = 'Complaints',
  COMPLAINTS_ADVANCED = 'Complaints_Advanced',
  COMPLAINTS_FOS_INPUT = 'Complaints_FOS_Input',
  COMPLAINTS_EDIT_RESOLVED = 'Complaints_EditResolved',
  CONSENT_TO_RESIDE = 'ConsentToReside',
  COVENANTS = 'Covenants',
  CURRENT_EXPOSURE = 'GroupExposure',
  CUSTOMER_CENTRIC = 'Customers',
  CUSTOMER_CENTRIC_KYC = 'Customers_KYC',
  CUSTOMER_CENTRIC_NOTES = 'Activities',
  CUSTOMER_CENTRIC_VULNERABILITY = 'Vulnerability',
  CUSTOMERS = 'Customers',
  CUSTOMERS_FINANCIAL_CRIME = 'Customers_Financial_Crime',
  CUSTOMERS_GDPR = 'Customers_GDPR',
  CUSTOMERS_INSOLVENCY = 'Customers_Insolvency',
  CUSTOMERS_KYC = 'Customers_KYC',
  CUSTOMERS_OVERVIEW = 'Customers',
  CUSTOMERS_PARTICIPANTS = 'Customers_Participants',
  CUSTOMER_REPRESENTATIVES = 'Customers_Related_Parties',
  ACCOUNT_REPRESENTATIVES = 'Customers_Related_Parties',
  CUSTOMERS_VULNERABILITY = 'Vulnerability',
  CUSTOMERS_ADDITIONAL_SUPPORT_NEEDS = 'AdditionalSupportNeeds',
  LINK_CUSTOMER = 'link_Customer',
  UNLINK_CUSTOMER = 'Unlink_Customer',
  MANAGE_SECOND_CHARGE = 'Manage_SecondCharge',
  MANAGE_RELATIONSHIP_MANAGER_NAME = 'Manage_Relationship',
  DD_MANAGEMENT = 'Dd_Management',
  DM_PROCESS_OVERRIDE_MODE = 'DM_Process_Override_Mode',
  DOCUMENTS = 'Activities',
  DUE_DAY_CHANGE = 'Due_Day_Change',
  ENTITIES = 'Customers',
  ENTITIES_OVERVIEW = 'Customers',
  EXECUTE_FULL_REDEMPTIONS = 'Execute_Redemption_Quote',
  EXECUTE_OVERPAYMENT = 'Execute_Redemption_Quote',
  REVERSE_REDEMPTION_QUOTE = 'Reverse_Redemption_Quote',
  EXIT_MODULES = 'Exit_Modules',
  FIELD_AGENT = 'Arrears_Field_Agent',
  FLEXIBLE_FEATURE = 'Flexible_Feature',
  FULL_REDEMPTIONS = 'Redemption',
  GOVERNMENT_SCHEME = 'Government_Scheme',
  GROUP_CONFIG = 'GroupExposure',
  GROUP_EXPOSURE = 'GroupExposure',
  GROUPEXPOSURE_COVENANTS = 'GroupExposure_Covenants',
  GROUPEXPOSURE_KYC = 'Customers_KYC',
  HIGH_RISK_JURISDICTION = 'Maintain_High_Risk_Jurisdictions',
  INCOME_EXPENDITURE = 'Income_Expenditure',
  INTEREST_CHARGE_HISTORY = 'Interest_Charge_History',
  AMORTISATION_PROFILE = 'Interest_Charge_History',
  INVOICE = 'Invoice',
  INVOICE_DELETE_REQUESTED = 'Invoice_DeleteRequested',
  COMMUNICATION = 'Communication',
  NON_STANDARD_COSTS = 'Non_Standard_Costs',
  OVERPAYMENT = 'Redemption',
  PAYMENT_HOLIDAY = 'Payment_Holiday',
  PAYMENT_REVIEW = 'Payment_Review',
  PENDING_DOCUMENTS = 'Activities',
  PRODUCT_SWITCH = 'Product_Switch',
  PRODUCT_SWITCH_UPDATE = 'Product_Switch',
  LITIGATION = 'Litigation',
  RECEIVERSHIP = 'Receivership',
  REDEMPTION_WAIVE = 'Redemption_Waive',
  REDEMPTION_WRITEOFF = 'Redemption_WriteOff',
  DUEDATECHANGE_STUBINTERESTWAIVE = 'DueDateChange_StubInterestWaive',
  REFUNDS = 'Refunds',
  REGISTRATION_LAND_CHARGES_TITLE_NUMBER = 'Registration_Land_Charges_Title_Number',
  REPAYMENT_STRATEGY = 'Repayment_Strategy',
  REPAYMENT_STRATEGY_EXPOSURE = 'GroupExposure',
  RESTRUCTURE = 'Restructure',
  ROLES_AND_PERMISSIONS = 'Roles_Permissions',
  SCOPES_GROUPS = 'Scopes_Groups',
  SEARCH = 'Account',
  SECURITY = 'Security',
  SECURITY_ABANDONMENT = 'Security_Abandonment',
  SECURITY_AMENDMENTS_ORDERS = 'Security_Amendments_Orders',
  SECURITY_AMENDMENTS_DEED = 'Security_Amendments_Deed',
  SECURITY_AMENDMENTS_DWELLINGS = 'Security_Amendments_Dwellings',
  SECURITY_AMENDMENTS_LAND = 'Security_Amendments_Land',
  SECURITY_DEEDS_TRACKER = 'Security_Deeds_Tracker',
  SECURITY_DEMANDS = 'Security_Demands',
  SECURITY_INSURANCE = 'Insurance',
  SECURITY_LETTINGS = 'Security_Lettings',
  SECURITY_OVERVIEW = 'Security',
  SECURITY_PARTIAL_RELEASES = 'Security_Partial_Releases',
  SECURITY_REPORT_REQUESTS = 'Security_Report_Requests',
  PORTAL_BLOCK = 'Portal_Block',
  SECURITY_TITLE_CHARGES = 'Title_Charges',
  SECURITY_VOLUNTARY_SURRENDER = 'Voluntary_Surrender',
  SECURITY_OCCUPANTS = 'Security_Occupants',
  FORM_RETURNED_APPROVAL = 'Form_Returned_Approval',
  SOF_ADVANCED = 'Sof_Advanced',
  ACCOUNT_REMEDIATION_ACCESS = 'Account_Remediation_Screen_Access',
  SOURCE_OF_FUND_REDEMPTIONS = 'Sof_Redemptions',
  SOF_SCREEN_ACCESS = 'Sof_Screen_Access',
  SUSPICIOUS = 'Activities',
  TARIFF_OF_CHARGES = 'Tariff_Of_Charges',
  MORTGAGE_MORATORIUM = 'Mortgage_Moratorium',
  BRAND_SETTINGS = 'Portfolio_Config',
  ROLL_LOAN_ENGINE = 'LE_SystemAdmin',
  THIRD_PARTY = '3rdParties',
  THIRD_PARTY_CHILD = '3rdParties',
  TRANSACTION = 'Transactions',
  TRANSACTION_CODES = 'Transaction_Codes',
  TRANSACTIONS = 'Transactions',
  USERS = 'Users',
  VALUATIONS = 'Valuations',
  VERTICAL_LOG = 'Vertical_Log',
  CALLLOG_DYNAMICSETTINGS = 'CallLog_DynamicSettings',
  DRAWDOWN = 'DrawdownRequest',
  SECURITY_OCCUPANTS_EDIT_CLOSED = 'Security_Occupants_Edit_Closed',
  EDIT_3RD_PARTY_PASSWORD = 'Edit_3rd_party_password',
  RETENTIONS = 'Retentions',
  FAILED_COMPLETIONS = 'Failed_Completions',
  CUSTOMERS_BTL_CCJ = 'BTL_CCJ',
  JOB_SCHEDULER = 'JobSchedulerAdmin',
  SCOPE_TRANSFER = 'Scope_Transfer',
  CASE_OWNER_MANAGER = 'Assign_Case_Owner',
  CASE_OWNER_ALLOCATION = 'Assign_Case_Owner',
  CASE_OWNER = 'Being_Case_Owner',
  MANDATES = 'Manage_Mandates',
  ASSIGN_MANDATES = 'Assign_Mandates',
}

export enum AppSectionsPermissionsKey {
  ACCOUNT = 'Account',
  ACCOUNT_CHANGE = 'Account_Change',
  ACCOUNT_CHILD = 'Account',
  ACCOUNT_INFORMATION = 'Account',
  CONSENT_TO_RESIDE = 'ConsentToReside',
  DEMARCATION = 'Demarcation',
  ARRANGEMENT_TO_PAY = 'Arrangement_To_Pay',
  ARREARS = 'Arrears',
  BASE_RATE_CHANGES = 'Base_Rate_Changes',
  BASE_RATE_TYPES = 'Base_Rate_Changes',
  BUSINESS_RULES = 'Workflow_SystemAdmin',
  BREATHING_SPACE = 'Breathing_Space',
  CALLS = 'Activities',
  CHART_ARREARS = 'Chart_Arrears',
  CHART_COMPLAINTS = 'Chart_Complaints',
  CHART_DELINQUENCY = 'Chart_Delinquency',
  CHART_LOAN_MATURITY_DISTRIBUTION = 'Chart_Loan_Maturity_Distribution',
  CHART_TO_DO_LIST = 'Chart_To_Do_List',
  CHART_VULNERABILITY = 'Chart_Vulnerability',
  CHART_ACCOUNT_ATDATE = 'Chart_Account_As_AtDate_Summary',
  CHART_BUSINESS_RULE = 'Chart_BusinessRule_History',
  COMPLAINTS = 'Complaints',
  COMPLAINTS_ADVANCED = 'Complaints_Advanced',
  COMPLAINTS_FOS_INPUT = 'Complaints_FOS_Input',
  COMPLAINTS_EDIT_RESOLVED = 'Complaints_EditResolved',
  COVENANTS = 'Covenants',
  CURRENT_EXPOSURE = 'GroupExposure',
  CUSTOMER_CENTRIC = 'Customers',
  CUSTOMER_CENTRIC_KYC = 'Customers_KYC',
  CUSTOMER_CENTRIC_NOTES = 'Activities',
  CUSTOMER_CENTRIC_DASHBOARD = 'Customers',
  CUSTOMER_CENTRIC_RELATIONSHIPS = 'Customers',
  CUSTOMER_CENTRIC_VULNERABILITY = 'Vulnerability',
  CUSTOMERS = 'Customers',
  CUSTOMERS_FINANCIAL_CRIME = 'Customers_Financial_Crime',
  CUSTOMERS_GDPR = 'Customers_GDPR',
  CUSTOMERS_INSOLVENCY = 'Customers_Insolvency',
  CUSTOMERS_KYC = 'Customers_KYC',
  CUSTOMERS_OVERVIEW = 'Customers',
  CUSTOMERS_PARTICIPANTS = 'Customers_Participants',
  CUSTOMER_REPRESENTATIVES = 'Customers_Related_Parties',
  ACCOUNT_REPRESENTATIVES = 'Customers_Related_Parties',
  CUSTOMERS_VULNERABILITY = 'Vulnerability',
  CUSTOMERS_ADDITIONAL_SUPPORT_NEEDS = 'AdditionalSupportNeeds',
  LINK_CUSTOMER = 'link_Customer',
  UNLINK_CUSTOMER = 'Unlink_Customer',
  MANAGE_SECOND_CHARGE = 'Manage_SecondCharge',
  MANAGE_RELATIONSHIP_MANAGER_NAME = 'Manage_Relationship',
  DD_MANAGEMENT = 'Dd_Management',
  DM_PROCESS_OVERRIDE_MODE = 'DM_Process_Override_Mode',
  DOCUMENTS = 'Activities',
  DUE_DAY_CHANGE = 'Due_Day_Change',
  ENTITIES = 'Customers',
  ENTITIES_OVERVIEW = 'Customers',
  EXECUTE_FULL_REDEMPTIONS = 'Execute_Redemption_Quote',
  EXECUTE_OVERPAYMENT = 'Execute_Redemption_Quote',
  REVERSE_REDEMPTION_QUOTE = 'Reverse_Redemption_Quote',
  EXIT_MODULES = 'Exit_Modules',
  FIELD_AGENT = 'Arrears_Field_Agent',
  FLEXIBLE_FEATURE = 'Flexible_Feature',
  FULL_REDEMPTIONS = 'Redemption',
  GOVERNMENT_SCHEME = 'Government_Scheme',
  GROUP_CONFIG = 'GroupExposure',
  GROUP_EXPOSURE = 'GroupExposure',
  GROUPEXPOSURE_COVENANTS = 'GroupExposure_Covenants',
  GROUPEXPOSURE_KYC = 'Customers_KYC',
  HIGH_RISK_JURISDICTION = 'Maintain_High_Risk_Jurisdictions',
  INCOME_EXPENDITURE = 'Income_Expenditure',
  INTEREST_CHARGE_HISTORY = 'Interest_Charge_History',
  AMORTISATION_PROFILE = 'Interest_Charge_History',
  INVOICE = 'Invoice',
  INVOICE_DELETE_REQUESTED = 'Invoice_DeleteRequested',
  NON_STANDARD_COSTS = 'Non_Standard_Costs',
  NOTES = 'Notes',
  OVERPAYMENT = 'Redemption',
  PAYMENT_HOLIDAY = 'Payment_Holiday',
  PAYMENT_REVIEW = 'Payment_Review',
  PENDING_DOCUMENTS = 'Activities',
  PRODUCT_SWITCH = 'Product_Switch',
  PRODUCT_SWITCH_UPDATE = 'Product_Switch',
  LITIGATION = 'Litigation',
  RECEIVERSHIP = 'Receivership',
  REDEMPTION_WAIVE = 'Redemption_Waive',
  REDEMPTION_WRITEOFF = 'Redemption_WriteOff',
  DUEDATECHANGE_STUBINTERESTWAIVE = 'DueDateChange_StubInterestWaive',
  REFUNDS = 'Refunds',
  REGISTRATION_LAND_CHARGES_TITLE_NUMBER = 'Registration_Land_Charges_Title_Number',
  REPAYMENT_STRATEGY = 'Repayment_Strategy',
  REPAYMENT_STRATEGY_EXPOSURE = 'GroupExposure',
  RESTRUCTURE = 'Restructure',
  SEARCH = 'Account',
  SEARCH_CHILD = 'Search',
  SECURITY = 'Security',
  SECURITY_ABANDONMENT = 'Security_Abandonment',
  SECURITY_AMENDMENTS_ORDERS = 'Security_Amendments_Orders',
  SECURITY_AMENDMENTS_DEED = 'Security_Amendments_Deed',
  SECURITY_AMENDMENTS_DWELLINGS = 'Security_Amendments_Dwellings',
  SECURITY_AMENDMENTS_LAND = 'Security_Amendments_Land',
  SECURITY_DEEDS_TRACKER = 'Security_Deeds_Tracker',
  SECURITY_DEMANDS = 'Security_Demands',
  SECURITY_INSURANCE = 'Insurance',
  SECURITY_LETTINGS = 'Security_Lettings',
  SECURITY_OVERVIEW = 'Security',
  SECURITY_PARTIAL_RELEASES = 'Security_Partial_Releases',
  SECURITY_REPORT_REQUESTS = 'Security_Report_Requests',
  PORTAL_BLOCK = 'Portal_Block',
  SECURITY_TITLE_CHARGES = 'Title_Charges',
  SECURITY_VOLUNTARY_SURRENDER = 'Voluntary_Surrender',
  FORM_RETURNED_APPROVAL = 'Form_Returned_Approval',
  ACCOUNT_REMEDIATION_ACCESS = 'Account_Remediation_Screen_Access',
  SOF_ADVANCED = 'Sof_Advanced',
  SOURCE_OF_FUND_REDEMPTIONS = 'Sof_Redemptions',
  SOF_SCREEN_ACCESS = 'Sof_Screen_Access',
  SUPER_USER = 'Roles_Permissions',
  SUPER_USER_ROLES_AND_PERMISSIONS = 'Roles_Permissions_Screen_Access',
  SUPER_USER_SCOPES_GROUPS = 'Scopes_Groups_Screen_Access',
  SUPER_USER_USERS = 'Users_Screen_Access',
  SUSPICIOUS = 'Activities',
  TARIFF_OF_CHARGES = 'Tariff_Of_Charges',
  MORTGAGE_MORATORIUM = 'Mortgage_Moratorium',
  BRAND_SETTINGS = 'Portfolio_Config',
  ROLL_LOAN_ENGINE = 'LE_SystemAdmin',
  THIRD_PARTY = '3rdParties',
  THIRD_PARTY_CHILD = '3rdParties',
  TRANSACTION = 'Transactions',
  TRANSACTION_CODES = 'Transaction_Codes',
  TRANSACTIONS = 'Transactions',
  VALUATIONS = 'Valuations',
  VERTICAL_LOG = 'Vertical_Log',
  CALLLOG_DYNAMICSETTINGS = 'CallLog_DynamicSettings',
  DRAWDOWN = 'DrawdownRequest',
  SECURITY_OCCUPANTS_EDIT_CLOSED = 'Security_Occupants_Edit_Closed',
  EDIT_3RD_PARTY_PASSWORD = 'Edit_3rd_party_password',
  RETENTIONS = 'Retentions',
  CUSTOMERS_BTL_CCJ = 'BTL_CCJ',
  ACCOUNT_TRANSFER = 'Account_Portfolio_Transfer',
  JOB_SCHEDULER = 'JobSchedulerAdmin',
  SCOPE_TRANSFER = 'Scope_Transfer',
  CASE_OWNER_MANAGER = 'Assign_Case_Owner',
  CASE_OWNER_ALLOCATION = 'Assign_Case_Owner',
  CASE_OWNER = 'Being_Case_Owner',
  MANDATES = 'Manage_Mandates',
  ASSIGN_MANDATES = 'Assign_Mandates',
  SUSPEND_LAND_REGISTRY_CHECKS = 'Suspend_Land_Registry_Checks',
}
